import React from 'react';
import PropTypes from 'prop-types';

import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';

import ConfirmModal from 'components/ConfirmModal';
import Footer from 'components/ConfirmModal/Footer';
import Content from 'components/ConfirmModal/Content';
import Title from 'components/ConfirmModal/Title';
import Text from 'components/ConfirmModal/Text';
import ButtonLoader from 'components/Loader/ButtonLoader';

class ConfirmPinModal extends React.PureComponent {
  render() {
    return (
      <ConfirmModal onClose={this.props.onClose} isOpen={this.props.isOpen}>
        <form onSubmit={this.props.onSubmit}>
          <Content>
            <Title style={{ marginBottom: '16px' }}>Пин публикации</Title>

            <Text>
              Пин публикации приведёт к замене старой публикации.<br />
              Вы действительно хотите запинить эту публикацию?
            </Text>
          </Content>

          <Footer>
            <PrimaryButton type="submit" style={{ width: '91px', marginRight: '16px' }}>
              {this.props.loading ? <ButtonLoader /> : 'Да'}
            </PrimaryButton>

            <SecondaryButton type="button" onClick={this.props.onClose}>
              отменить
            </SecondaryButton>
          </Footer>
        </form>
      </ConfirmModal>
    );
  }
}

ConfirmPinModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
};

ConfirmPinModal.defaultProps = {
  onClose: () => {},
  isOpen: false,
  onSubmit: () => {},
  loading: false,
};

export default ConfirmPinModal;
